import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';
import type { FlagConfiguration } from '@atlassian/jira-flags';
import messages from './messages.tsx';

export const UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.updateIssueParentErrorTitle,
	description: messages.updateIssueParentGenericErrorDescription,
	messageId:
		'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-generic-flag.error.error.update-item-parent-fail-generic-flag',
	messageType: 'transactional',
};

export const UPDATE_ITEM_PARENT_FAIL_400_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.updateIssueParentErrorTitle,
	description: messages.updateIssueParent400ErrorDescription,
	messageId:
		'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-400-flag.error.error.update-item-parent-fail-400-flag',
	messageType: 'transactional',
};

export const UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM: FlagConfiguration = {
	type: 'error',
	title: messages.updateIssueParentErrorTitle,
	description: messages.updateIssueParent400ErrorDescriptionIssueTermRefresh,
	messageId:
		'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-400-flag-with-issue-term.error.error.update-item-parent-fail-400-flag-with-issue-term',
	messageType: 'transactional',
};

export const UPDATE_ITEM_PARENT_FAIL_404_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.updateIssueParentErrorTitle,
	description: messages.updateIssueParent404ErrorDescription,
	messageId:
		'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-404-flag.error.error.update-item-parent-fail-404-flag',
	messageType: 'transactional',
};

export const UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM: FlagConfiguration = {
	type: 'error',
	title: messages.updateIssueParentErrorTitle,
	description: messages.updateIssueParent404ErrorDescriptionIssueTermRefresh,
	messageId:
		'business-list-handlers.controllers.update-issue-parent.update-item-parent-fail-404-flag-with-issue-term.error.error.update-item-parent-fail-404-flag-with-issue-term',
	messageType: 'transactional',
};

export const getUpdateParentIssueExperience = (
	packageName: ExperienceDetails['packageName'],
): ExperienceDetails => ({
	experience: 'updateParentIssue',
	packageName,
	teamName: 'keystone',
});

export const SUCCEEDED = 'SUCCEEDED';

export const FAILED = 'FAILED';

export const PACKAGE_NAME = 'jiraBusinessListHandlers';
export const ERROR_ID = 'useUpdateIssueParent';
export const TEAM_NAME = 'keystone';
